import { render } from "./DowntimesServicesAdd.vue?vue&type=template&id=3cddc3b4"
import script from "./DowntimesServicesAdd.vue?vue&type=script&lang=js"
export * from "./DowntimesServicesAdd.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__